import { render, staticRenderFns } from "./AddToProjects.vue?vue&type=template&id=15cf631f&scoped=true&"
import script from "./AddToProjects.vue?vue&type=script&lang=js&"
export * from "./AddToProjects.vue?vue&type=script&lang=js&"
import style0 from "./AddToProjects.vue?vue&type=style&index=0&id=15cf631f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cf631f",
  null
  
)

export default component.exports